// extracted by mini-css-extract-plugin
export var bodyRow = "_g7-d";
export var cardColumns = "_g7-e";
export var ellipsesOverflow = "_g7-2";
export var flatBottomCorners = "_g7-3";
export var flatTopCorners = "_g7-4";
export var headerActionsDropdown = "_g7-f";
export var headerBottomRow = "_g7-c";
export var headerTopRow = "_g7-b";
export var orderDetailsWrapper = "_g7-0";
export var orderInfoContainer = "_g7-1";
export var productDetails = "_g7-9";
export var productImage = "_g7-5";
export var responsiveTable = "_g7-8";
export var shipmentContainer = "_g7-a";
export var tableBottomLeft = "_g7-6";
export var tableBottomRight = "_g7-7";
export var trackingLink = "_g7-g";